import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'radio',
        name: 'type',
        title: 'Yükleme Türü',
        default: 'capture',
        rules: {},
        options: {
            type: 'locale',
            data: [
                {text: 'Resim Çek', value: 'capture'},
                {text: 'Resim Yükle', value: 'upload'},
                {text: 'Resimsiz Hareket', value: 'noImage'},
            ],
        },
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'file',
        connectField: 'type',
        connectFieldValue: ['upload'],
        name: 'image',
        title: 'Resim',
        placeHolder: 'Ürün ile ilgili resim yükleyin',
        rules: {required: false},
        modal: ['image'],
        data: ['image'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'camera',
        connectField: 'type',
        connectFieldValue: ['capture'],
        name: 'image',
        title: 'Resim',
        placeHolder: 'Ürün ile ilgili resim yükleyin',
        rules: {required: false},
        modal: ['image'],
        data: ['image'],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Dealer/forms/movementImage.js